module.exports = __webpack_public_path__ + "static/ally-CFC-b7e027c0f43129d825e981c5f3e9d567.png";